
















































import { defineComponent, watch, ref, computed } from 'vue-demi';
import { useI18n } from 'common-module/src/util/useI18n';
import RecordSuccessComponent from './RecordSuccessComponent.vue';
import RecordLoadingComponent from './RecordLoadingComponent.vue';
import RecordFailComponent from './RecordFailComponent.vue';
import { useRootInstance } from 'common-module/src/util/useRootInstance';
import { resolveUrl } from '@zk/framework-vue';
export default defineComponent({
  name: 'RecorderPreviewDialog',
  components: {
    RecordSuccessComponent,
    RecordLoadingComponent,
    RecordFailComponent
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onOpen: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    recordUpload: {
      type: Object,
      default: null
    },
    previewData: {
      type: Object,
      default: null
    }
  },
  setup(props) {

    const dialogVisible = ref(false);

    const state = ref<'loading' | 'success' | 'fail' | ''>('');

    const previewOptions = ref(props.previewData);

    const instance = useRootInstance();

    const { t } = useI18n();

    const previewTitle = computed(
      () => {
        if (state.value === 'fail') {
          return t('recorderPreview.failTitle');
        }
        if (state.value === 'success') {
          return `${t('recorderPreview.successTitle')} `;
        }
        if (state.value === 'loading') {
          return t('recorderPreview.loadingTitle');
        }
        return t('recorderPreview.previewTitle');
      }
    );

    watch(
      () => props.visible,
      (val) => {
        dialogVisible.value = val;
      },
      { immediate: true }
    );

    function sendNotice() {
      if (typeof window.Notification === 'undefined' || Notification.permission !== 'granted') {
        return;
      }
      const notice = new Notification(t('notice.recorder.uploaded'));
      notice.onclick = () => {
        notice.close();
        window.focus();
      };
    }

    const handleOpen = () => {
      (props.onOpen as Function)?.();
      if (props.recordUpload) {
        state.value = 'loading';
      } else if (props.previewData) {
        state.value = 'success';
      }
    };

    const handleClose = () => {
      if (dialogVisible.value) {
        instance.eventBus.$emit('recorder-function-guide:show');
        dialogVisible.value = false;
      }
      
      (props.onClose as Function)?.();
    };

    const handleLoadingSuccess = (data: any) => {
      previewOptions.value = data;
      state.value = 'success';
      sendNotice();
      instance.eventBus.$emit('recorder:uploaded', data.videoUrl, data.videoCode, data.videoName, data.videoAuthor, data.audioText);
    };

    const handleDelete = () => {
      state.value = '';
      dialogVisible.value = false;
      instance.eventBus.$emit('recorder-function-guide:show');
      instance.$track.send('Delete_Video', { File_View: '视频预览弹窗' }, true);
    };

    const handleNameUpdate = (name: string) => {
      previewOptions.value.videoName = name;
      instance.eventBus.$emit('recorder:nameUpdate');
      instance.$track.send('Edit_VideoName', { Edit_Path: '视频预览弹窗' }, true);
    };

    const handleNewRecord = () => {
      dialogVisible.value = false;
      instance.eventBus.$emit('recorder:start', {}, 'recorderPreview');
    };


    const handleCreateWork = async () => {
      console.log('createWork');
      const isStorageAllow = await instance.$store.dispatch('user/checkStorageRight');
      if (!isStorageAllow) {
        return;
      }
      dialogVisible.value = false;
      instance.eventBus.$emit('recorder:create', {
        ...previewOptions.value
      });
      instance.$track.send('OnVideo_CreateIssue', { Create_Path: '视频预览弹窗' }, true);
    };

    const handlePreviousLink = () => {
      window.open(resolveUrl(`${instance.$config.VUE_APP_PMS_URL}/setting/recorder?from=preview`));
    };

    const handleLoadingFail = () => {
      state.value = 'fail';
    };


    return {
      t,
      dialogVisible,
      state,
      previewTitle,
      previewOptions,
      handleClose,
      handleOpen,
      handleLoadingSuccess,
      handleLoadingFail,
      handleDelete,
      handleNewRecord,
      handleCreateWork,
      handleNameUpdate,
      handlePreviousLink
    };

  }
});
